<div class="text-18px">
  <div class="flex flex-wrap gap-y-10px">
    <div class="min-w-300px flex">
      <rb-checkbox class="mr-13px"
                   [class.clickable]="!('' | bookingChangeInProgress)"
                   [checked]="vaps.selected"
                   [disabled]="'' | bookingChangeInProgress"
                   (click)="onClick()"></rb-checkbox>
      <div [class.cursor-not-allowed]="'' | bookingChangeInProgress"
           [class.clickable]="!('' | bookingChangeInProgress)"
           class="font-semibold"
           (click)="onClick()">{{ vaps.title }}
      </div>
    </div>
    <div class="ml-40px grow-6">{{ 'VAPS.PRICE' | translate:{price: vaps.price} }}</div>
  </div>
  <div class="ml-40px mt-10px">{{ vaps.description }}</div>
</div>
